"use client";

import { motion, type Variants } from "motion/react";

import {
	getVariants,
	type IconProps,
	IconWrapper,
	useAnimateIconContext,
} from "@/components/animate-ui/icons/icon";

type CirclePlusProps = IconProps<keyof typeof animations>;

const animations = {
	default: {
		circle: {},
		line1: {
			initial: {
				rotate: 0,
				transition: { ease: "easeInOut", duration: 0.4, delay: 0.1 },
			},
			animate: {
				rotate: 90,
				transition: { ease: "easeInOut", duration: 0.4, delay: 0.1 },
			},
		},
		line2: {
			initial: {
				rotate: 0,
				transition: { ease: "easeInOut", duration: 0.4 },
			},
			animate: {
				rotate: 90,
				transition: { ease: "easeInOut", duration: 0.4 },
			},
		},
	} satisfies Record<string, Variants>,
} as const;

function IconComponent({ size, ...props }: CirclePlusProps) {
	const { controls } = useAnimateIconContext();
	const variants = getVariants(animations);

	return (
		<motion.svg
			xmlns="http://www.w3.org/2000/svg"
			width={size}
			height={size}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth={2}
			strokeLinecap="round"
			strokeLinejoin="round"
			{...props}
		>
			<motion.circle
				cx={12}
				cy={12}
				r={10}
				variants={variants.circle}
				initial="initial"
				animate={controls}
			/>
			<motion.line
				x1={8}
				y1={12}
				x2={16}
				y2={12}
				variants={variants.line1}
				initial="initial"
				animate={controls}
			/>
			<motion.line
				x1={12}
				y1={16}
				x2={12}
				y2={8}
				variants={variants.line2}
				initial="initial"
				animate={controls}
			/>
		</motion.svg>
	);
}

function CirclePlus(props: CirclePlusProps) {
	return <IconWrapper icon={IconComponent} {...props} />;
}

export {
	animations,
	CirclePlus,
	CirclePlus as CirclePlusIcon,
	type CirclePlusProps,
	type CirclePlusProps as CirclePlusIconProps,
};
